import { ExitType } from './ExitType';

export const ExitTypeOptions = [
    {
        id: ExitType.Sale,
        name: 'Sale',
        shortName: 'Sale',
        sortOrder: 1,
        active: true,
    },
    {
        id: ExitType.Refinance,
        name: 'Refinance',
        shortName: 'Refinance',
        sortOrder: 2,
        active: true,
    },
];
